import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "pagoForzado" | "observaciones";
export type Buttons = "aceptar" | "cancelar";

export const resolucionAltaFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "pagoForzado",
      label: "Forzar pago (ignorar reglas de vigencia)",
      bts: { mCol: 12 },
      component: ICheckBuilder,
      props: {}
    },
    {
      name: "observaciones",
      label: "Observaciones",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        rows: 4
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar Resolución",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {},
  rows: [["pagoForzado"], ["observaciones"], ["aceptar", "cancelar"]]
};
